import { Pipe, PipeTransform } from '@angular/core';
import { isFullLoadRawMode } from '../utils/raw-mode.utils';

@Pipe({
    name: 'isFullLoadRawMode',
    pure: true,
    standalone: false
})
export class IsFullLoadRawModePipe implements PipeTransform {
    transform(value: any) {
        return typeof value === 'string' && isFullLoadRawMode(value);
    }
}
